module.exports = __webpack_public_path__ + "static/media/store.ff43a2a1.svg";